module.exports = __webpack_public_path__ + "static/media/icot3-dark.545f4b38.svg";